import React from 'react';
function Footer() {
    return (
        <div>
            <h1>Made And Developed by @Laxmi Menon</h1>
        </div>
    );
}

export default Footer;